export type Lang = 'ko' | 'en'

// Use a mapped type so every locale satisfies the same interface
export type Translations = {
  nav: { about: string; products: string; contact: string; blog: string }
  hero: { label: string; words: readonly string[]; headline: string; desc: string; scroll: string }
  about: {
    keywords: readonly string[]
    theme: string
    workNumber: string
    workTitle: string
    cultureNumber: string
    cultureTitle: string
    stackCards: readonly { title: string; desc: string }[]
  }
  work: { label: string; title: string }
  contact: {
    label: string; title: string
    emailLabel: string; phoneLabel: string; addressLabel: string
    nameField: string; namePlaceholder: string
    phoneField: string; phonePlaceholder: string
    emailField: string; emailPlaceholder: string
    typeField: string; typePlaceholder: string
    messageField: string; messagePlaceholder: string
    submit: string
  }
  blog: {
    label: string; title: string; desc: string
    allCategory: string; empty: string; back: string; related: string
    infoLabel: string; authorLabel: string; dateLabel: string
    categoryLabel: string; tagsLabel: string
  }
  footer: {
    rights: string
    desc: string
    contactLabel: string
    links: readonly { label: string; href: string }[]
  }
}

const ko: Translations = {
  // ── Header ──
  nav: {
    about: 'About',
    products: 'Products',
    contact: 'Contact',
    blog: 'Blog',
  },
  // ── Hero ──
  hero: {
    label: '도어락 · 열쇠 전문 업체',
    words: ['지킵니다.', '엽니다.', '고칩니다.', '책임집니다.'],
    headline: '당신의 문을\n가장 안전하게\n',
    desc: 'SafeLock은 디지털 도어락 설치·수리부터 긴급 개방까지\n현관 보안의 모든 것을 책임집니다.',
    scroll: 'Scroll',
  },
  // ── About ──
  about: {
    keywords: [
      '디지털 도어락', '스마트 도어락', '긴급출동', '열쇠 복제',
      '도어락 설치', '도어락 수리', '유리문 도어락', '보조키',
      '스마트홈 연동', '현관 보안',
    ],
    theme: 'Theme',
    workNumber: '600+',
    workTitle: 'Work',
    cultureNumber: '8+',
    cultureTitle: 'Years',
    // 스택 카드 = 제공 서비스
    stackCards: [
      { title: '도어락 설치', desc: '번호·카드·지문·푸시풀, 유리문·특수문까지 문에 맞춰 시공' },
      { title: '수리·점검', desc: '오작동·방전·인식 불량, 증상별 진단과 수리' },
      { title: '긴급 개방', desc: '잠김·비밀번호 분실 시 파손 최소화 개방' },
      { title: '열쇠 복제·교체', desc: '보조키 복제부터 실린더 교체까지' },
    ],
  },
  // ── Work ──
  work: {
    label: 'Our Work',
    title: 'Selected Projects',
  },
  // ── Contact ──
  contact: {
    label: 'Contact',
    title: '지금 바로\n문의하세요',
    emailLabel: 'Email',
    phoneLabel: 'Phone',
    addressLabel: 'Address',
    nameField: '이름',
    namePlaceholder: '홍길동',
    phoneField: '연락처',
    phonePlaceholder: '010-5918-8245',
    emailField: '이메일',
    emailPlaceholder: 'hello@example.com',
    typeField: '문의 유형',
    typePlaceholder: '도어락 설치 / 수리 / 긴급 개방 / 열쇠 복제 / 기타',
    messageField: '메시지',
    messagePlaceholder: '현관문 종류, 증상, 원하시는 제품 등을 알려주세요.',
    submit: '보내기 →',
  },
  // ── Blog ──
  blog: {
    label: 'Blog',
    title: 'Insights &\nStories',
    desc: 'SafeLock이 도어락 전문지식, 생활 팁, 상황별 대처법, 제품 이야기를 전합니다.',
    allCategory: '전체',
    empty: '해당 카테고리에 포스트가 없습니다.',
    back: '← 블로그로 돌아가기',
    related: '관련 포스트',
    infoLabel: '포스트 정보',
    authorLabel: '작성자',
    dateLabel: '날짜',
    categoryLabel: '카테고리',
    tagsLabel: '태그',
  },
  // ── Footer ──
  footer: {
    rights: 'All rights reserved.',
    desc: '도어락 설치·수리·긴급출동, 현관 보안의 모든 것을 책임집니다.',
    contactLabel: 'Contact',
    links: [
      { label: 'Blog', href: '/blog' },
    ],
  },
}

// 한국어 전용 사이트 — 언어 토글은 제거했지만, 이후 영어 지원이 필요해지면
// 이 별칭을 실제 영어 번역 객체로 교체하면 된다.
const translations: Record<Lang, Translations> = {
  ko,
  en: ko,
}

export function getT(lang: Lang): Translations {
  return translations[lang]
}
